import {
  parallaxView,
} from '@utils/parallax'

import {
  fortuneWheel,
} from '@utils/fortune-wheel'

import seoTextTrigger from '@utils/seo-text'
import accordion from '@utils/accordion'
import roundPrices from '@utils/intl'
import addHorizontalScrolling from '@utils/horizontal-scrolling'
import createDecor from '@utils/decor'

import { enableParallax } from '@utils/academy_parallax.js'
import sliderControl from '@utils/slider-controls'

import '@utils/filters'

import SnapSlider from '@tannerhodges/snap-slider';

import {
  checkLogo,
  scrolly,
  fakeModalCloser,
  zIndexFixer,
  loyaltyTabs,
  generateTextAnchors,
  baseTabs,
} from './ui-scripts'

import {
  typoHandler,
} from './typo'

const sliderParent = () => {
  const sliders = Array.from(document.getElementsByClassName('js-sibling-slider'))
  sliders.forEach(slider => {
    if (!slider.SnapSlider) return
    slider.SnapSlider.on('change', () => {
      const sl = sliders.filter(s => s !== slider)
      sl.forEach(s => {
        if (!s.SnapSlider) return
        const id = [...slider.children].findIndex(e => e === slider.SnapSlider.getCurrentSlide())
        s.SnapSlider.goto(id + 1, { focus: false })
      })
    })
  })
}

// const slider = new SnapSlider('')
document.addEventListener('DOMContentLoaded', () => {
  roundPrices()
  checkLogo()
  scrolly()
  fortuneWheel()
  parallaxView()
  sliderControl()
  seoTextTrigger()
  accordion()
  fakeModalCloser()
  zIndexFixer()
  addHorizontalScrolling()
  createDecor()
  loyaltyTabs()
  enableParallax()
  generateTextAnchors()
  sliderParent()
  baseTabs()
})

typoHandler()
